<template>
  <div>
    <div v-if="isBusy" class="loader"></div>
    <p v-if="isBusy" class="text-center load-text">Les données sont en cours de chargement...</p>
    <b-form v-else @submit.prevent="onSubmit">
      <b-form-group
        v-for="field in fields"
        v-if="(field.inFormCondition && field.inFormCondition(form)) || !field.inFormCondition"
        :key="field.name"
        :label="field.label+' :'"
        :label-for="field.name"
      >
        <b-form-select
          v-if="field.type == 'select'"
          :id="field.name"
          v-model="form[field.name]"
          :options="options[field.name+'_options']"
          :required="field.required"
          :disabled="!options[field.name+'_options'] || !options[field.name+'_options'].length"
        >
          <template slot="first">
            <option
              v-if="!options[field.name+'_options'] || !options[field.name+'_options'].length"
              :value="null"
              disabled
            >{{ field.firstOption ? field.firstOption : 'Chargement ...'}}</option>
            <option v-else :value="null">-- Sélectionnez une option --</option>
          </template>
        </b-form-select>
        <Chosen
          v-else-if="field.type=='chosen'"
          :id="field.name"
          v-model="form[field.name]"
          :options="options[field.name+'_options']"
          :required="field.required"
          :disabled="!options[field.name+'_options'] || !options[field.name+'_options'].length"
          placeholder="-- Sélectionnez une option --"
          label="text"
          trackBy="value"
        ></Chosen>
        <b-form-radio-group
          v-else-if="field.type=='yesno'"
          v-model="form[field.name]"
          :options="[
            {value: true, text: 'Oui'},
            {value: false, text: 'Non'},
          ]"
          buttons
          button-variant="outline-primary"
          :required="field.required"
        ></b-form-radio-group>
        <div class="textarea-wrapper" v-else-if="field.type=='textarea'">
          <b-form-textarea
            :id="field.name"
            v-model="form[field.name]"
            :required="field.required"
            rows="3"
            max-rows="6"
          />
        </div>
        <datepicker
          v-else-if="field.type=='date'"
          :id="field.name"
          input-class="form-control"
          v-model="form[field.name]"
          :required="field.required"
          :format="'dd/MM/yyyy'"
          :language="fr"
          :clear-button="true"
          clear-button-icon="fa fa-times fa-lg"
        ></datepicker>
        <draggable
          class="group_repeater"
          v-else-if="field.type=='group_repeater'"
          @start="drag=true"
          @end="drag=false; onEnd();"
          v-model="form[field.name]"
          :options="{disabled: !canDrag}"
          :class="'drag--'+canDrag"
        >
          <div
            class="field_group d-flex flex-wrap"
            v-for="(field_group, field_group_index) in form[field.name]"
            :key="field_group_index"
          >
            <a class="group-repeater__grab" v-if="field.canDrag">
              <img src="/static/img/pictos/drag2.svg" alt />
            </a>
            <template v-for="(sub_field, sub_field_index) in field.fields">
              <b-form-select
                class="flex-fill"
                :key="sub_field_index"
                v-if="sub_field.type == 'select'"
                :id="sub_field.name"
                v-model="field_group[sub_field.name]"
                :options="options[sub_field.name+'_options']"
                :required="sub_field.required"
                :disabled="!options[sub_field.name+'_options'] || !options[sub_field.name+'_options'].length"
              >
                <template slot="first">
                  <option
                    v-if="!options[sub_field.name+'_options'] || !options[sub_field.name+'_options'].length"
                    :value="null"
                    disabled
                  >{{ sub_field.firstOption ? sub_field.firstOption : 'Chargement ...'}}</option>
                  <option v-else :value="null">-- Sélectionnez une option --</option>
                </template>
              </b-form-select>
              <Chosen
                class="flex-fill"
                :key="sub_field_index"
                v-else-if="sub_field.type=='chosen'"
                :id="sub_field.name"
                v-model="form[sub_field.name]"
                :options="options[sub_field.name+'_options']"
                :required="sub_field.required"
                :disabled="!options[sub_field.name+'_options'] || !options[sub_field.name+'_options'].length"
                placeholder="-- Sélectionnez une option --"
                label="text"
                trackBy="value"
              ></Chosen>
              <template v-else-if="sub_field.type=='file'">
                <div
                  class="group-repeater__image-container"
                  v-if="field_group && field_group[sub_field.name] && (field_group[sub_field.name].includes('.jpg') || field_group[sub_field.name].includes('.png'))"
                  :key="sub_field_index"
                >
                  <img
                    class="group-repeater__image"
                    v-if="field_group[sub_field.name] && field_group.id"
                    :src="imagesurl+'300/'+field_group[sub_field.name]"
                  />
                </div>
                <div class="group-repeater__file-container" v-else :key="sub_field_index">
                  <a :href="imagesurl+field_group[sub_field.name]" target="_blank">
                    <img src="/static/img/pictos/file.svg" alt />
                  </a>
                </div>
                <div class="group-repeater__actions-container" :key="sub_field_index">
                  <b-form-input
                    class="file-preview flex-fill"
                    :key="sub_field_index"
                    v-if="field_group[sub_field.name] && field_group.id"
                    type="text"
                    v-model="field_group[sub_field.name]"
                    disabled
                  />
                  <b-form-file
                    :key="sub_field_index"
                    v-else
                    :id="sub_field.name"
                    v-model="field_group[sub_field.name]"
                    :state="Boolean(field_group[sub_field.name])"
                    placeholder="Sélectionnez un fichier..."
                    drop-placeholder="Déposez un fichier ici..."
                    :required="sub_field.required"
                  ></b-form-file>
                </div>
              </template>
              <datepicker
                :key="sub_field_index"
                v-else-if="sub_field.type=='date'"
                :id="sub_field.name"
                v-model="form[sub_field.name]"
                :required="sub_field.required"
                :format="'dd/MM/yyyy'"
                :wrapper-class="flex-fill"
                :input-class="'form-control'"
                :language="fr"
                :clear-button="true"
                clear-button-icon="fa fa-times fa-lg"
              ></datepicker>
              <b-form-input
                class="flex-fill input-field"
                :key="sub_field_index"
                v-else
                :id="sub_field.name"
                :type="sub_field.type"
                :step="sub_field.step || null"
                v-model="field_group[sub_field.name]"
                :required="sub_field.required"
                :placeholder="sub_field.label"
              />
            </template>
            <b-button
              variant="outline-secondary"
              @click="deleteGroupRepeater(field.name, field_group_index)"
            >
              <i class="far fa-trash-alt"></i>
            </b-button>
          </div>
          <b-button variant="outline-secondary" @click="addGroupRepeater(field.name)">
            Ajouter un élément
            <i class="far fa-plus"></i>
          </b-button>
        </draggable>
        <b-form-input
          v-else
          :id="field.name"
          :type="field.type"
          :step="field.step || null"
          v-model="form[field.name]"
          :required="field.required"
          :disabled="field.disabled"
        />
      </b-form-group>
      <div class="form-submit">
        <b-button type="submit" variant="outline-primary" :disabled="inSaving" class="btn-edit">
          {{ inSaving ? 'Enregistrement...' : 'Enregistrer' }}
          <i
            v-if="!inSaving"
            class="fa fa-chevron-right"
          ></i>
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import Chosen from "@/components/Global/Chosen";

export default {
  name: "AdminForm",
  components: {
    draggable,
    Datepicker,
    Chosen
  },
  props: ["config", "form", "isBusy", "options"],
  data() {
    return {
      fields: {},
      inSaving: false,
      en: en,
      fr: fr,
      canDrag: 1
    };
  },
  computed: {
    imagesurl() {
      return process.env.BACK_UPLOADS_URL;
    }
  },
  mounted() {
    // Chargement des champs à afficher dans le form depuis la config pour les passer au composant AdminForm
    this.fields = this.config.fields.filter(field => field.inForm == true);
  },
  methods: {
    onEnd() {
      const self = this;
      for (var i = 0; i < this.form.photos.length; i++) {
        self.$http
          .patch("photo/" + this.form.photos[i].id, {
            position: i + 1
          })
          .then(function() {});
      }

      for (var j = 0; j < this.form.specifications.length; j++) {
        if (this.form.specifications[j].id) {
          self.$http
            .patch("specification/" + this.form.specifications[j].id, {
              display_order: j + 1
            })
            .then(function() {});
        }
      }
    },
    onSubmit() {
      this.inSaving = true;

      // Si une fonction de validation du formulaire est définie, on l'exacute
      if (
        this.config.valide_form_function &&
        this.config.valide_form_function(this.form) !== true
      ) {
        this.$toastr.error(this.config.valide_form_function(this.form));
        this.inSaving = false;
        return false;
      }

      // Validation custom pour les champs datepicker
      let validation = true;
      this.fields.forEach(field => {
        if (
          field.required &&
          field.required === true &&
          (typeof this.form[field.name] === "undefined" ||
            !this.form[field.name])
        ) {
          // Avant de considérer le champ comme non rempli, on vérifie quand même qu'il est bien affiché dans le form
          if (!field.inFormCondition || field.inFormCondition(this.form)) {
            this.$toastr.error("Veuillez renseigner le champ " + field.label);
            validation = false;
          }
        }
      });
      if (validation !== true) {
        this.inSaving = false;
        return false;
      }

      // Edition
      if (this.form.id) {
        this.$store
          .dispatch(
            this.config.store_namespace + "/saveItem",
            this.config.submit_formatter
              ? this.config.submit_formatter(this.form)
              : this.form
          )
          .then(response => {
            this.$emit("submit:update:success", response);
            if (this.config.use_edit_modal) {
              this.$root.$emit("bv::hide::modal", "admin_modal_form");
            } else if (this.config.redirect_after_edit_route_name) {
              this.$router.push({
                name: this.config.redirect_after_edit_route_name
              });
            } else {
              this.$router.go(-1);
            }
          })
          .catch(error => {
            this.$emit("submit:update:error", error);
            this.inSaving = false;
          });
      }
      // Création
      else {
        this.$store
          .dispatch(
            this.config.store_namespace + "/addItem",
            this.config.submit_formatter
              ? this.config.submit_formatter(this.form)
              : this.form
          )
          .then(response => {
            this.$emit("submit:create:success", response);
            if (this.config.use_new_modal) {
              this.$root.$emit("bv::hide::modal", "admin_modal_form");
            } else if (this.config.redirect_after_create_route_name) {
              this.$router.push({
                name: this.config.redirect_after_create_route_name
              });
            } else {
              this.$router.push({ name: this.config.list_route_name });
            }
          })
          .catch(error => {
            this.$emit("submit:create:error", error);
            this.inSaving = false;
          });
      }
    },
    /**
     * Supprime un item d'un champ de type 'group_repeater'
     * @param   {string}    field_name    Nom du champ de type 'group_repeater'
     * @param   {integer}   index         Index de l'item à supprimer
     */
    deleteGroupRepeater(field_name, index) {
      // Si le champ est requis, on s'assure qu'il reste au minimum 1 item
      if (
        this.config.fields.find(field => field.name == field_name).required &&
        this.form[field_name].length == 1
      ) {
        this.$toastr.warning(
          "Ce champ est requis et doit donc comporter au minimum un élément"
        );
        return;
      }
      this.form[field_name].splice(index, 1);
    },
    /**
     * Ajoute un item dans un champ de type 'group_repeater'
     * @param   {string}    field_name    Nom du champ de type 'group_repeater'
     */
    addGroupRepeater(field_name) {
      let field = { ...this.form }[field_name];
      let field_group = {};
      this.config.fields
        .find(field => field.name == field_name)
        .fields.forEach(field => {
          field_group[field.name] = null;
        });
      field.push(field_group);
      this.form[field_name] = field;
      this.canDrag = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

// Forms
.form-group label {
  text-transform: uppercase;
  margin-left: 20px;
  &.custom-file-label {
    margin-left: 0;
    text-transform: initial;
    line-height: 1.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 80px;
  }
}
.form-group .btn-group {
  .btn-outline-primary:not(:disabled):not(.disabled):active,
  .btn-outline-primary:not(:disabled):not(.disabled).active {
    background-color: $color1;
    border-color: $color1;
  }
  label {
    margin-left: 0;
    &:not(:disabled):not(.disabled) {
      cursor: pointer;
    }
  }
}
input.form-control,
.custom-select,
textarea.form-control,
.custom-file-label {
  font-size: 12px;
  padding-left: 20px;
}
input.form-control,
.custom-select,
.custom-file,
.custom-file-input,
.custom-file-label {
  height: calc(1.5em + 0.75rem + 10px);
}
.custom-file {
  min-width: 250px;
}
.custom-file-label::after {
  height: 100%;
  border-top-right-radius: 99px;
  border-bottom-right-radius: 99px;
  content: "Ouvrir" !important;
  line-height: 1.5rem;
}
.file-preview {
  text-overflow: ellipsis;
}
.textarea-wrapper {
  overflow: hidden;
}
textarea.form-control {
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #e5e6e7;
    border-radius: 5px;
    transition: color 0.15s ease-in-out 0s;
  }
  &:focus {
    &::-webkit-scrollbar-thumb {
      background: $color1;
    }
  }
}
.group_repeater {
  border-radius: 20px;
  padding: 0;
  margin-bottom: 25px;
  .field_group {
    margin-bottom: 16px;
    input.form-control,
    .custom-select,
    .custom-file {
      width: auto;
      margin-right: 20px;
    }
    input.form-control {
      margin-right: 0;
      flex: 1;
      text-align: center;
    }
    input.form-control.input-field {
      margin-right: 20px;
    }
  }
  &.drag--0 {
    .group-repeater {
      &__grab {
        background-color: lightgrey;
      }
    }
  }
}
.btn-outline-secondary {
  font-size: 12px;
  margin: 0;
}
.group-repeater {
  display: flex;
  margin-bottom: 20px;
  border: 1px solid white;
  &__grab {
    width: 100px;
    background-color: $color3;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-right: 20px;
    img {
      height: 20px;
    }
  }
  &__actions-container {
    display: flex;
    flex-direction: column;
    margin-right: 20px;
  }
  &__image-container,
  &__file-container {
    flex: 1;
  }
  &__file-container {
    a {
      display: block;
      height: 100%;
      margin-left: 80px;
      img {
        display: block;
        height: 100%;
      }
    }
  }
  &__image {
    width: 200px;
    height: auto;
  }
  &.sortable-ghost {
    border: 1px solid lightgrey;
  }
}
.delete-repeater {
  margin-bottom: 16px;
}
.btn-primary {
  background-color: $color1;
  border-color: $color1;
  font-size: 12px;
}
.btn-edit {
  background-color: $color1;
  color: white;
  border: none;
  &:hover {
    background-color: $color2;
  }
}
.load-text {
  font-size: 13px;
}
</style>

<style lang="scss">
.chosen-container .chosen-single {
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
  font-size: 12px;
  color: #495057 !important;
  padding-left: 20px;
  height: calc(1.5em + 0.75rem + 10px);
  line-height: calc(1.5em + 0.75rem + 10px);
  background: #fff;
  div b {
    margin-top: 7px;
  }
}
.chosen-container-active.chosen-with-drop .chosen-single {
  background: #fff;
}
.custom-file-label::after {
  content: "Parcourir" !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Global/AdminForm.vue